import { useQuery } from "@tanstack/react-query";

import { getBeefHerdSize, getBeefHerdSizeAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_HERD_SIZE } from "consts";

import { FootprintingBeefHerdSize } from "models";

export const useGetFootprintingBeefHerdSize = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<FootprintingBeefHerdSize[]>({
    queryKey: [FOOTPRINTING_BEEF_HERD_SIZE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefHerdSizeAdmin(primaryDataId) : getBeefHerdSize(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
